import $ from "jquery";
import Cookies from "js-cookie";

import utils from "../helpers/utils";

function init(): void {
  const $cookieMessage = $(".js-cookie-message");
  // Show message if it exists and we haven't got the cookie set
  if ($cookieMessage.length && !utils.convertToBoolean(Cookies.get("SeenCookieMessage"))) {
    $cookieMessage.addClass("reveal");
  }
  // When the X is clicked, set the cookie and hide the messaging
  $(".js-dismiss-cookie-message").click(function () {
    $cookieMessage.removeClass("reveal");
    Cookies.set("SeenCookieMessage", true, {
      expires: 365,
      path: "/",
      secure: true,
    });
    return false;
  });
}

export default { init };
